<template>
  <div>
    <div>
      <div class="w100 content3">
        <div class="title">
          <h4>合作伙伴</h4>
        </div>
        <div class="banner222">
          <div class="box2">
            <img src="@/assets/images/index/banner_1.png" />
            <img src="@/assets/images/index/banner_2.png" />
            <img src="@/assets/images/index/banner_3.png" />
          </div>
          <div class="box2">
            <img src="@/assets/images/index/banner_4.png" />
            <img src="@/assets/images/index/banner_5.png" />
            <img src="@/assets/images/index/banner_6.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.box2 {
  text-align: center;
  margin: 0 auto;
  width: 992px;
  height: 140px;
  /* margin-left: 400px; */
  margin-bottom: 59px;
  float: left;
  text-align: center;
}
.box2 img {
  width: 268px;
  height: 140px;
  margin-right: 59px;
  margin-left: 0px;
  border: 1px solid rgba(193, 193, 193, 1);
  border-radius: 2px;
}
.banner222 {
  width: 936px;
  height: 339px;
  margin-left: auto;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Partnership.vue